/** Duration of the sampled fluid spring when it is played through the Web Animations API. */
export const fluidDuration = 360;

/**
 * Critically damped spring (response 0.3s), sampled for the Web Animations API, which cannot read
 * the `--ease-fluid` CSS token.
 */
export const fluidEasing =
  'linear(0, 0.0547, 0.1726, 0.309, 0.4408, 0.5577, 0.656, 0.7361, 0.7997, 0.8493, 0.8874, 0.9164, 0.9383, 0.9547, 0.9668, 0.9758, 0.9824, 0.9872, 0.9908, 0.9934, 0.9952, 0.9966, 0.9975, 0.9982, 1)';
